import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Mode = 'light' | 'dark' | 'system';

interface ThemeState {
  mode: Mode;
  resolved: 'light' | 'dark';
  setMode: (m: Mode) => void;
  toggle: () => void;
  hydrate: () => void;
}

const systemPrefersDark = () =>
  typeof window !== 'undefined' &&
  window.matchMedia?.('(prefers-color-scheme: dark)').matches;

const apply = (resolved: 'light' | 'dark') => {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('dark', resolved === 'dark');
};

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      mode: 'system',
      resolved: 'light',
      setMode: (m) => {
        const resolved = m === 'system' ? (systemPrefersDark() ? 'dark' : 'light') : m;
        apply(resolved);
        set({ mode: m, resolved });
      },
      toggle: () => {
        const next = get().resolved === 'dark' ? 'light' : 'dark';
        apply(next);
        set({ mode: next, resolved: next });
      },
      hydrate: () => {
        const m = get().mode;
        const resolved = m === 'system' ? (systemPrefersDark() ? 'dark' : 'light') : m;
        apply(resolved);
        set({ resolved });
      },
    }),
    { name: 'ofi-cia-theme' },
  ),
);
